const firebaseConfig = {
  apiKey: "AIzaSyDlIz62xvTQFxyZdASlLgJvv8PiKHW-Q0Y",
  authDomain: "dayknow-e54e9.firebaseapp.com",
  projectId: "dayknow-e54e9",
  storageBucket: "dayknow-e54e9.firebasestorage.app",
  messagingSenderId: "635433835932",
  appId: "1:635433835932:web:53a99ea07ca05e89957c59",
  measurementId: "G-8WFCVJQP1P",
};

export default firebaseConfig;
